import { NgClass, NgIf, isPlatformBrowser } from '@angular/common'
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core'

@Component({
  selector: 'app-social-share',
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass]
})
export class SocialShareComponent {
  @Input() title: string
  @Input() darkTheme = true

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  url: string = isPlatformBrowser(this.platformId)
    ? encodeURI(window.location.href)
    : null
}
